import { Category } from '@modules/common/types';
import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  Tooltip,
  Typography,
} from '@mui/material';
import { upperFirst } from 'lodash';
import capitalize from 'lodash/capitalize';
import { useMeasure } from 'react-use';
import { CategoryIcon } from '../CategoryIcon';

const CategoryValues = [
  Category.Complaint,
  Category.Improvement,
  Category.Praise,
  Category.Help,
];

interface EditCategoryWidgetProps extends ToggleButtonGroupProps {
  selectedCategory?: Category;
  updateSelectedCategory: (category: Category) => void;
  iconSize?: number;
}

export const EditCategoryWidget = ({
  selectedCategory,
  updateSelectedCategory,
  iconSize,
  ...toggleButtonGroupProps
}: EditCategoryWidgetProps) => {
  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    newCategory: Category,
  ) => {
    if (!newCategory) {
      return;
    }
    updateSelectedCategory(newCategory);
  };

  const [toggleButtonRef, { width: availableWidth }] =
    useMeasure<HTMLDivElement>();

  return (
    <ToggleButtonGroup
      {...toggleButtonGroupProps}
      size="large"
      orientation={availableWidth > 400 ? 'horizontal' : 'vertical'}
      ref={toggleButtonRef}
      value={selectedCategory}
      onChange={handleChange}
      exclusive
      fullWidth
    >
      {CategoryValues.map((value) => (
        <ToggleButton
          value={value}
          key={value}
          sx={{
            textTransform: toggleButtonGroupProps.fullWidth
              ? undefined
              : 'none',
            bgcolor: 'background.paper',
            backgroundClip: 'padding-box',
            py: toggleButtonGroupProps.fullWidth ? 2.25 : undefined,
            px: toggleButtonGroupProps.fullWidth ? 2 : undefined,
          }}
        >
          <Tooltip arrow title={capitalize(value)} placement="top">
            <Stack direction="row" alignItems="center" spacing={1}>
              <Stack>
                <CategoryIcon category={value} size={iconSize} />
              </Stack>
              {!toggleButtonGroupProps.fullWidth && (
                <Typography variant="body2">{upperFirst(value)}</Typography>
              )}
            </Stack>
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
